import { Repeat, Plus, Trash2 } from "lucide-react";
import { t } from "../../i18n";
import { DateField } from "../DateField";

const PLAN_LABEL = { weekly: "everyWeek", monthly: "everyMonth", yearly: "everyYear", custom_dates: "ownDates" };

const CustomDates = ({ locale, dates, setDates, minDate, maxDates }) => (
  <div className="space-y-2" data-testid="custom-dates">
    <p className="smallcaps">{t(locale, "pickDates")}</p>
    {dates.map((d, i) => (
      <div key={i} className="flex gap-2 items-center">
        <DateField testid={`custom-date-${i}`} min={minDate} value={d}
                   onChange={(v) => setDates(dates.map((x, j) => (j === i ? v : x)))} />
        {dates.length > 1 ? (
          <button type="button" data-testid={`remove-date-${i}`} className="text-muted hover:text-danger"
                  onClick={() => setDates(dates.filter((_, j) => j !== i))}>
            <Trash2 size={15} />
          </button>
        ) : null}
      </div>
    ))}
    {dates.length < maxDates ? (
      <button type="button" className="btn-ghost text-xs inline-flex items-center gap-1"
              data-testid="add-custom-date" onClick={() => setDates([...dates, ""])}>
        <Plus size={13} /> {t(locale, "addDate")}
      </button>
    ) : null}
    <p className="text-xs text-muted">{t(locale, "cardSavedNote")} {t(locale, "endsAfterLast")}</p>
  </div>
);

export const RecurrenceCard = ({ locale, subOpts, giftCount, plan, setPlan, dates, setDates, minDate }) => {
  const recurring = plan !== "once";
  const pct = subOpts?.discount_percent;
  const options = [["once", t(locale, "oneOff")], ...(subOpts?.plans || []).map((p) => [p, t(locale, PLAN_LABEL[p])])];
  return (
    <div className="card p-5 space-y-4" data-testid="recurrence-card">
      <div className="flex items-center gap-2">
        <Repeat size={15} className="text-brass" />
        <h2 className="text-base text-ink">{t(locale, "howOften")}</h2>
      </div>
      {subOpts?.enabled && giftCount === 1 ? (
        <>
          <div className="grid sm:grid-cols-2 gap-3">
            {options.map(([k, label]) => (
              <button key={k} type="button" data-testid={`plan-${k}`} onClick={() => setPlan(k)}
                      className={`text-start text-sm px-4 py-3 border transition-colors focus:ring-2 focus:ring-brass ${
                        plan === k ? "border-brass bg-petal/20 text-ink" : "border-brass-light text-muted hover:text-ink"}`}>
                {label}
                {k !== "once" && pct ? <span className="block text-xs text-success mt-0.5">−{pct}%</span> : null}
              </button>
            ))}
          </div>
          {plan === "custom_dates" ? (
            <CustomDates locale={locale} dates={dates} setDates={setDates} minDate={minDate} maxDates={subOpts?.max_dates || 12} />
          ) : null}
          {recurring ? (
            <div className="text-xs text-muted space-y-1" data-testid="recurrence-note">
              {pct ? <p className="text-success">− {pct}% {t(locale, "planDiscount")}</p> : null}
              <p>{t(locale, "planPriceLocked")}</p>
              <p>{t(locale, "planRouting")}</p>
            </div>
          ) : null}
        </>
      ) : (
        <p className="text-xs text-muted" data-testid="recurrence-unavailable">
          {giftCount > 1 ? t(locale, "oneOff") : t(locale, "recurringOff")}
        </p>
      )}
    </div>
  );
};
